import sswsTicker from '../components/ssws-ticker';

const header_menu_actions = function(){
  if ( $('#header-menu-wrapper .menu-header.secondary').length === 0 ){
    return;
  }
  $('#header-menu-wrapper .menu-header').on('click', function(){
    var target = $(this).data('target');
    if ($(this).hasClass('secondary')){
        if( $(target).hasClass('show')){
          $(target).hide('fast').removeClass('show');
        } else {
          $(target).show('fast').addClass('show');
          $('#header-menu-wrapper .navbar>div:not(' + target + ')' ).hide('fast').removeClass('show');
        }
    } else {
        if( $(target).hasClass('show')){
          $(target).hide('fast').removeClass('show');
        } else {
          $(target).show('fast').addClass('show');
          $('#header-menu-wrapper .navbar>div:not(' + target + ')' ).hide('fast').removeClass('show');
        }
    }
  });
};

const fixDynamicFrame = function() {
  $('iframe').each(function() {
    const $iframe = $(this);

    // Don't overwrite an existing title
    if ($iframe.attr('title')) {
      return;
    }

    let title = '';

    // Try to find a nearby heading
    const $container = $iframe.closest(
      '.wp-block-group, .wp-block-column, section'
    );

    if ($container.length) {
      const $heading = $container.find('h2, h3, h4').first();

      if ($heading.length) {
        title = $.trim($heading.text());
      }
    }

    // Fallback
    if (!title) {
      title = 'Inbäddat innehåll';
    }

    $iframe.attr('title', title);
  });
};


export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('ambea-website common.js LOADED');

    fixDynamicFrame();

    const iframeObserver = new MutationObserver(function() {
      fixDynamicFrame();
    });

    iframeObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    /* SEARCH */
    var $search = $('header.banner .search-form');

    $search.submit(function(e) {

      if ($(window).width() >= 992) {
        return true;
      }

      e.preventDefault();
      $search.toggleClass('open');
      let $input = $search.find('.search-field');
      $input.focus();

    });
    header_menu_actions();
    sswsTicker.init();

    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
      document.body.classList.add('ios-device');
    }

    setTimeout( function(){
      jQuery('.mf-kpi-table').each(function(){
          let tableid = jQuery(this).children('table').attr('id');
          let $scrollableDiv = jQuery(this);

          jQuery(this).parent('.wp-block-group').append('<div class="custom-scroll-bar-sec" id="'+tableid+'-scr"><div class="custom-scroll-bar" id="'+tableid+'-bar"></div></div>');
          let $customScrollbar = jQuery('#'+tableid+'-scr');
          let $scrollThumb = jQuery('#'+tableid+'-bar');

          let scrollbarWidth = $customScrollbar.width();
          let contentWidth = jQuery('#'+tableid).width();
          let containerWidth = $scrollableDiv.width();

          let thumbWidth = Math.max((containerWidth / contentWidth) * scrollbarWidth, 50);
          $scrollThumb.css('width', thumbWidth + 'px');

          $scrollableDiv.on('scroll', function () {
              let scrollRatio = $scrollableDiv.scrollLeft() / (contentWidth - containerWidth);
              $scrollThumb.css('left', scrollRatio * (scrollbarWidth - thumbWidth) + 'px');
          });
      });
    },2000);

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
